import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import NotificationHistoryCard from '../../components/NotificationHistoryCard';
import { HostSettingsLayout } from '../../components/HostSettingsLayout';
import RoleNotificationPrefsCard from '../../components/RoleNotificationPrefsCard';
import { fetchAccountSettings, fetchNotificationHistory, updateAccountNotifications } from '../../utils/accountSettingsApi';

export default function VenueNotificationsPage() {
  const [notifications, setNotifications] = useState({});
  const [prefsConfig, setPrefsConfig] = useState({});
  const [history, setHistory] = useState([]);
  const activeVenueAppId = typeof window !== 'undefined' ? window.localStorage.getItem('activeVenueAppId') : null;

  useEffect(() => {
    const load = async () => {
      try {
        const [settings, historyItems] = await Promise.all([
          fetchAccountSettings(),
          fetchNotificationHistory({ scope: 'venue', venueAppId: activeVenueAppId }),
        ]);
        setNotifications(settings.notifications || {});
        setPrefsConfig(settings.notification_prefs_config || {});
        setHistory(historyItems || []);
      } catch (error) {
        toast.error('Failed to load notification settings');
      }
    };
    load();
  }, [activeVenueAppId]);

  // Auto-save: each toggle persists immediately (optimistic, with rollback
  // on failure). No "Done" button needed.
  const persist = async (next, previous) => {
    setNotifications(next);
    try {
      await updateAccountNotifications(next);
    } catch (error) {
      setNotifications(previous);
      toast.error(error.response?.data?.detail || 'Failed to update notifications');
    }
  };

  const handleToggle = (key) => {
    const current = notifications[key] !== false;
    const next = { ...notifications, [key]: !current };
    persist(next, notifications);
  };

  return (
    <HostSettingsLayout title="Notifications & History" dataTestId="venue-notifications-page">
      <RoleNotificationPrefsCard
        role="venue"
        config={prefsConfig}
        notifications={notifications}
        onToggle={handleToggle}
        testIdPrefix="venue-notifications-prefs"
      />

      <NotificationHistoryCard notifications={history} dataTestIdPrefix="venue-notifications-history" />
    </HostSettingsLayout>
  );
}
